/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import React from "react";
import {Popover, Steps} from "antd";


const { Step } = Steps;

// @ts-ignore
const customDot = (dot: any, { status, index }) => (
    <Popover
        content={
            <span>
        step {index} status: {status}
      </span>
        }
    >
        {dot}
    </Popover>
);

export const UserProgressComponent = ()=>{
    return <>
        {/*<Progress percent={5} steps={5}  size="small" strokeColor="#52c41a" style={{background: "#fff"}} />*/}
        {/*<Steps style={{backgroundColor: '#fff'}} size={'small'}>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*    <Step title={"Connect an Exchange"}/>*/}
        {/*</Steps>*/}
        </>
}
